(function () {
  var checkbox = document.querySelector('.sub-bundle-checkbox');
  if (!checkbox) return;

  var sellingPlanId = checkbox.getAttribute('data-selling-plan-id');

  // Find the main ATC form — has a submit button with name="add"
  var atcForm = null;
  var forms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var i = 0; i < forms.length; i++) {
    if (forms[i].querySelector('[name="add"]')) {
      atcForm = forms[i];
      break;
    }
  }
  if (!atcForm) return;

  var planInput = document.createElement('input');
  planInput.type = 'hidden';
  planInput.name = 'selling_plan';
  planInput.value = '';
  atcForm.appendChild(planInput);

  checkbox.addEventListener('change', function () {
    planInput.value = (checkbox.checked && sellingPlanId) ? sellingPlanId : '';
  });
})();
